<template>
  <div>
    <vue-headful title="Locatie" />
    <Header :page_title="user_token ? 'Locatie' : 'Aanmelden'" />
    <div class="container-fluid app-body">
      <NotificationContainer />
      <register-steps v-if="!form.id && !user_token" :steps="{1:'Gegevens',2:'Aan de slag!'}" totalAnswered="66" currentStep="1" />
      <div v-if="!form.id && !user_token" class="sd-title medium" style="margin-bottom: 20px;">
        <span class="steps">2/3</span>
        Accountgegevens
      </div>
    </div>
    <div v-if="false" class="mb-4 pb-1">
      <gmap-map
        v-if="center"
        :center="center"
        :zoom="8"
        :options="{
          mapTypeControl: false,
          scaleControl: false,
          disableDefaultUi: false,
          streetViewControl: false,
          fullscreenControl: false,
          scrollwheel: false,
          disableDoubleClickZoom: true,
          clickableIcons: false,
          styles: [
            {
              stylers: [
                {
                  saturation: -100
                }
              ]
            }
          ]
        }"
        style="width:100%;  height: 200px;"
      >
        <gmap-marker
          :position="marker.position"
          :draggable="draggable"
          @dragend="getMarkerPosition($event.latLng)"
        ></gmap-marker>
      </gmap-map>
    </div>
    <div class="container-fluid">
      <form @submit.prevent="onSubmit" v-on:change="onFormChange($event)" class="sd-form">
        <div class="">
          <div class="">
            <div class="form-group w-square-icon" hidden>
              <input v-model="form.lat" type="hidden" required />
              <input v-model="form.lng" type="hidden" required />
              <div class="icon-wrapper search position-absolute align-self-center">
                <i class="material-icons">place</i>
              </div>
            </div>
            <div class="mb-4">
              <div class="sd-title mini right-line mb-20px">
                <span class="title-text"><svg-icon icon="address" />Adresgegevens</span>
              </div>
              <div class="input-row">
                <div class="sd-col-12 sd-input">
                  <label>Naam locatie <span class="required">*</span></label>
                  <input
                    type="text"
                    class="form-control require"
                    placeholder="Naam locatie *"
                    v-model="form.name_location"
                    autocomplete="nope"
                    required
                  />
                </div>
              </div>
              <div class="input-row">
                <div class="sd-col-6 sd-input">
                  <label>Straat <span class="required">*</span></label>
                  <input
                    type="text"
                    class="form-control require"
                    placeholder="Straat *"
                    v-model="form.street"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="sd-col-3 sd-input">
                  <label>Nummer <span class="required">*</span></label>
                  <input
                    type="text"
                    class="form-control require"
                    placeholder="Nummer *"
                    v-model="form.street_number"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="sd-col-3 sd-input">
                  <label>Toevoeging</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Toevoeging"
                    v-model="form.house_addition"
                    autocomplete="nope"
                    maxlength="7"
                  />
                </div>
              </div>
              <div class="input-row">
                <div class="sd-col-5 sd-input">
                  <label>Postcode <span class="required">*</span></label>
                  <input
                    type="text"
                    class="form-control require"
                    placeholder="Postcode *"
                    v-model="form.postal_code"
                    autocomplete="nope"
                    required
                  />
                </div>
                <div class="sd-col-7 sd-input">
                  <label>Plaats <span class="required">*</span></label>
                  <input
                    type="text"
                    class="form-control require"
                    placeholder="Plaats *"
                    v-model="form.city"
                    autocomplete="nope"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="false" class="form-group mb-3 pb-1">
            <p>
              <strong>Bereikbaarheid</strong>
            </p>
            <textarea
              v-model="form.accessibility"
              class="form-control"
              placeholder="Toelichting"
              rows="5"
            ></textarea>
          </div>
          <Required />
          <button
            type="submit"
            class="btn btn-warning btn-block"
            v-if="!form.id && !user_token"
          >Volgende</button>
          <button
            type="submit"
            class="btn btn-warning btn-block"
            v-if="!form.id && user_token"
          >Locatie toevoegen</button>
          <button type="submit" class="btn btn-warning btn-block" v-if="form.id">Opslaan</button>
          <button
            v-if="form.id && !is_used && !default_address"
            @click="deleteAddress"
            type="button"
            class="btn btn-gray btn-block"
          >Verwijder</button>
        </div>
      </form>
    </div>
    <Footer v-if="user_token" />
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user_token: null,
      required: "",
      form: {
        id: this.id,
        lat: "",
        lng: "",
        name_location: null,
        street: null,
        street_number: null,
        house_addition: null,
        postal_code: null,
        city: null,
        accessibility: ""
      },
      is_used: false,
      default_address: false,
      draggable: true,
      address: "",
      center: null,
      marker: {},
      place: {},
      currentPlace: null,
      prevRoute: null
    };
  },
  props: ["id"],
  async created() {},
  async mounted() {
    // this.geolocate();
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    is_used: {
      immediate: true,
      async handler() {
        this.draggable = this.is_used ? false : true;
      }
    },
    center: {
      immediate: true,
      handler: function() {
        // localStorage.setItem("form-pending", JSON.stringify(true));
        // console.log("oops center");
      },
      deep: true
    }
    // form: {
    //   immediate: true,
    //   handler: function() {
    //     localStorage.setItem("form-pending", JSON.stringify(true));
    //   }
    // },
  },
  methods: {
    validateAddress() {
      if (!this.form.lat || !this.form.lng) {
        this.form.location = "";
        // alert("Please use the map.");
      }
    },
    setPlace(place) {
      this.currentPlace = place;
      // this.form.location = place.formatted_address;
      this.updateNewAddress(this.currentPlace.address_components);
      this.addMarker();
    },
    addMarker() {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.marker = { position: marker };
        this.place = this.currentPlace;
        this.center = marker;
        this.currentPlace = null;
        this.form.lat = marker.lat;
        this.form.lng = marker.lng;
      }
    },
    geolocate: function() {
      if (!this.center) {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
        if (!this.center) {
          this.center = {
            lat: 52.1326,
            lng: 5.2913
          };
        }
      }
    },
    async geocode() {
      return new Promise(resolve => {
        this.$gmapApiPromiseLazy().then(() => {
         const geocoder = new google.maps.Geocoder();
         var form = this.form;
         const address = this.form.street_number + "+" + this.form.street + "+" + this.form.postal_code + "+" + this.form.city;
 
         geocoder.geocode({ address }, function(results, status) {
           if (status === "OK") {
             const latitude = results[0].geometry.location.lat();
             const longitude = results[0].geometry.location.lng();
             form["lat"] = latitude;
             form["lng"] = longitude;
             resolve({status:'ok'});
           } else {
              resolve({status:'fail'}); 
           }
         });
       }).catch(() => {
         resolve({status:'fail'});
       });
      });
    },
    updateNewAddress(results) {
      let arr = results;
      var components = {};
      jQuery.each(arr, function(k, v1) {
        jQuery.each(v1.types, function(k2, v2) {
          components[v2] = v1.short_name;
        });
      });
      // set new address
      var address = this.form;
      address["street"] = components.route ? components.route : null;
      address["street_number"] = components.street_number
        ? components.street_number
        : null;
      address["house_addition"] = components.house_addition
        ? components.house_addition
        : null;
      address["postal_code"] = components.postal_code
        ? components.postal_code
        : null;
      address["city"] = components.locality ? components.locality : null;
    },
    getMarkerPosition: function(marker) {
      // eslint-disable-next-line no-undef
      var geocoder = new google.maps.Geocoder();
      var form = this.form;
      var $this = this;

      geocoder.geocode(
        {
          latLng: {
            lat: marker.lat(),
            lng: marker.lng()
          }
        },
        function(results, status) {
          // eslint-disable-next-line no-undef
          if (status == google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              // form["location"] = results[0].formatted_address;
              $this.updateNewAddress(results[0].address_components);
              form["lat"] = marker.lat();
              form["lng"] = marker.lng();
              localStorage.setItem("form-pending", JSON.stringify(true));
            }
          }
        }
      );
      if (form["lat"] && form["lng"]) {
        this.center = {
          lat: marker.lat(),
          lng: marker.lng()
        };
      }
    },
    async fetchData() {
      this.$store.state.loading = true;

      this.required = this.$store.state.company_fields;
      this.user_token = JSON.parse(localStorage.getItem("user-token"));

      const ID = parseInt(this.id);
      if (ID) { //if edit
        let user = JSON.parse(localStorage.getItem("user"));
        let locations = user.addresses;
        const address = locations.find(obj => obj.id === ID);
        if (address) {
          await this.checkAPIAddress();
          for (var obj in address) {
            if (address[obj]) {
              this.form[obj] = address[obj];
            }
          }

          const marker = {
            lat: parseFloat(this.form.lat),
            lng: parseFloat(this.form.lng)
          };
          this.marker = { position: marker };
          this.center = marker;
          this.$forceUpdate();
        }

        if (locations.length == 1) {
          this.default_address = true;
        }
      } else {
        let new_address = JSON.parse(localStorage.getItem("address"));
        // check if the user is logged in
        if (new_address) {
          delete this.form["id"]; // remove the id attribute

          for (obj in new_address) {
            if (new_address[obj]) {
              this.form[obj] = new_address[obj];
            }
          }
          const marker = {
            lat: parseFloat(this.form.lat),
            lng: parseFloat(this.form.lng)
          };
          this.marker = { position: marker };
          this.center = marker;
          this.$forceUpdate();
        } else {
          // geolocate
          // this.geolocate();
        }
      }
      localStorage.removeItem("form-pending");
      this.$store.state.loading = false;
    },
    async checkAPIAddress() {
      return new Promise(resolve => {
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        const ID = parseInt(this.id);
        this.$http
          .get(this.$apiURI + "/" + "address" + "/" + ID, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            resolve();
          })
          .catch(error => {
            const notification = {
              type: "warning",
              message: "Deze locatie is gekoppeld aan een vacature en kan daarom niet worden verwijderd. Het adres kan wel worden gewijzigd."
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.is_used = error.response.data.is_used;
            localStorage.removeItem("form-pending");
            resolve();
          });
      });
    },
    async saveAddress() {
      return new Promise(resolve => {
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/address";
        let formData = new FormData();
        for (var obj in this.form) {
          if (this.form[obj])
            formData.append(obj, this.form[obj]);
        }
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            localStorage.removeItem("form-pending");

            if (typeof dataLayer !== "undefined" && !this.id) {
              dataLayer.push({
                event: "SchoolLocationAdd",
                eventCategory: "School",
                eventAction: "School – Location add",
                eventLabel: "",
                eventValue: "1"
              });
            }

            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            this.$store.state.loading = false;
          });
      });
    },
    async deleteAddress() {
      const ID = parseInt(this.id);
      await this.deleteRecord("/address/" + ID);
      // continue only if resolve()
      await this.updateLocalUser();
      await this.redirectBack();
    },
    async onSubmit() {
      let geo = await this.geocode();
      if (geo.status) {
        if (this.user_token) {
          this.$store.state.loading = true;
          await this.saveAddress();
          await this.updateLocalUser();
          this.$store.state.loading = false;
          await this.redirectBack();
          // this.$router.replace({ name: "company-step_1" });
        } else {
          localStorage.setItem("address", JSON.stringify(this.form));
          await this.redirectBack();
        }
      }
    },
    async redirectBack() {
      return new Promise(() => {
        let url = this.user_token
          ? { name: "company-details", params: { action: 'save' } }
          : { name: "company-details", params: { action: 'next' } };
        // console.log(url);
        setTimeout(
          () =>
            this.$router.replace(url),
          800
        );
      });
    },
    onFormChange: function(event) {
      localStorage.setItem("form-pending", JSON.stringify(true));
		}
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.user_token) {
      this.savePending(to, from, next);
    } else {
      next();
    }
  },
  components: {
    // VueGoogleAutocomplete
  }
};
</script>

<style scoped>
.remove-bg {
  background: none;
}
.form-control[readonly] {
  opacity: 1;
}
</style>
